/**
 * Contact Builder lead-form Subjects (features/leadGenerators) carry a raw `fromPage` value —
 * that feature is shared across pages and has no opinion on what "ISM" means. This page is the
 * one place that translation belongs, since it's the only page today that opens Contact Builder
 * from Native ISM (data-lead-generator-opener="request-information" is only ever rendered by
 * that feature's floor-plan/housing-unit detail footers, with data-from-page values
 * "CommunityDetail.NativeInteractiveSiteMap.Plan" / "...Spec").
 */

/**
 * `fromPage` is always one of `CommunityDetail.NativeInteractiveSiteMap.Plan` / `...Spec` today —
 * take the trailing segment and prefix it, so a future third ISM section works without a code
 * change here.
 * @param {string|undefined} fromPage
 * @returns {string}
 */
function getPositionFromFromPage(fromPage) {
  const section = (fromPage ?? '').split('.').pop();
  return section ? `ISM-${section}` : 'ISM';
}

/**
 * Replaces a Contact Builder Subject payload's raw `fromPage` with this page's `position` value,
 * ready to hand to any of leadGenerators' build*Event functions (which all take `position`, not
 * `fromPage`).
 * @param {{ fromPage: string|undefined, [key: string]: unknown }} payload
 * @returns {object}
 */
function withPosition({ fromPage, ...payload }) {
  return { ...payload, position: getPositionFromFromPage(fromPage) };
}

export default withPosition;
